export const UnitLabel = ({ unit }: { unit: string }) => (
  <span className="text-base-30 text-m-r pointer-events-none select-none">{unit}</span>
);
